import { DATA } from './data';
import { POPULATION_INCREASE_EVENT_DURATION_MS } from './data/airportData';
import { COLORS } from './data/colors';
import { POPUP } from './popupManager';

const eventMessages = [
  'Trade fair ends in {city}, exhibitors and visitors are leaving the city!',
  'Hurricane approaches {city}, people trying to leave it!',
  'Major sports event in {city} has ended, fans are heading home!',
  'Tech conference concludes in {city}, attendees are departing!',
  'Festival in {city} comes to an end, visitors are leaving!',
  'Political rally in {city} finishes, crowds are dispersing!',
  'Film premiere in {city} wraps up, guests are flying out!',
  'Tourist season peaks in {city}, travelers are going back!',
  'University semester ends in {city}, students are heading home!',
  'Big holiday event in {city} ends, people are on the move!',
];

function getPopulationIncreaseText(airportName: string) {
  const randomIndex = Math.floor(Math.random() * eventMessages.length);
  const selectedEventMessage = eventMessages[randomIndex].replace('{city}', `<b style="color: ${COLORS.green_500}">${airportName}</b>`);
  return selectedEventMessage;
}

export function StartPopulationIncreaseManager() {
  setInterval(() => {
    const availableAirports = DATA.airports.filter((airport) => airport.isAvailable);
    if (availableAirports.length > 0) {
      const airport = availableAirports[Math.floor(Math.random() * availableAirports.length)];
      airport.beginPopulationIncreaseEvent();
      POPUP.showPopulationIncreaseEvent(airport, getPopulationIncreaseText(airport.name));
    }
  }, POPULATION_INCREASE_EVENT_DURATION_MS * 3);
}
